<template>
  <v-layout align-center justify-space-between class="px-2 mt-1">
    <!-- ページ制御 -->
    <v-layout align-center justify-start class="mr-2">
      <v-btn color="accent" height="28px" x-small :disabled="page <= 1" @click="$emit('update:page', page - 1)">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-sheet class="transparent">
        <v-select
          :value="page"
          single-line
          hide-details
          :items="pageNumberItems"
          class="mx-2 footer-select-box"
          dense
          solo
          @input="$emit('update:page', $event)"
        />
      </v-sheet>
      <span class="mr-1 caption"> / {{ totalPages }} {{ $tt('customPageSuffix') }} </span>
      <v-btn
        color="accent"
        height="40px"
        x-small
        :disabled="page >= totalPages"
        @click="$emit('update:page', page + 1)"
      >
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-layout>
    <v-spacer />
    <!-- 表示件数 -->
    <v-layout justify-end align-center class="ml-2">
      <span class="mr-1 caption">{{ $tt('customDisplayCount') }}</span>
      <v-sheet class="transparent">
        <v-select
          :value="pageSize"
          :items="pageSizeOptions"
          class="mx-2 footer-select-box"
          dense
          solo
          single-line
          hide-details
          @input="changePageSize($event)"
        />
      </v-sheet>
      <span class="mr-1 caption"> / {{ $tt('customTotalCount', { count: '' + total }) }} </span>
    </v-layout>
  </v-layout>
</template>

<script>
/**
 * ストアを介さないリスト用の簡易ページャー (圃場セット・VRAマップなどローカル配列のページング)。
 * PaginationComponent と見た目を揃えつつ、リスト直下に置けるようフッター固定にしない。
 * 使い方: :total="items.length" :page.sync="page" :page-size.sync="pageSize"
 */
export default {
  name: 'ListPagerComponent',
  props: {
    total: { type: Number, required: true },
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 20 },
  },
  data: () => ({
    pageSizeOptions: [{ value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }],
  }),
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pageNumberItems() {
      const items = []
      for (let i = 1; i <= this.totalPages; i++) {
        items.push(i)
      }
      return items
    },
  },
  methods: {
    changePageSize(size) {
      this.$emit('update:pageSize', size)
      this.$emit('update:page', 1)
    },
  },
}
</script>

<style scoped>
.footer-select-box {
  width: 64px;
  font-size: 12px;
}
.footer-select-box ::v-deep .v-input__control {
  min-height: 28px !important;
}
.footer-select-box ::v-deep .v-input__slot {
  min-height: 28px !important;
  padding: 0 0 0 8px !important;
  box-shadow: none !important;
  border: 1px solid rgba(128, 128, 128, 0.4);
}
.footer-select-box ::v-deep .v-input__append-inner {
  margin-top: 2px !important;
}
</style>
